'use client';

import { ListingPayload } from '@/slw/entities/seller/listing';

export function ListingStatus({ listing }: { listing: ListingPayload }) {
  return (
    <section>
      <ul
        className='block space-y-4 md:space-y-0 md:grid grid-cols-2 px-4 gap-x-8 gap-y-4
      list-disc font-medium text-sm'
      >
        {listing.titleStatus && (
          <li>
            <span>Title status:</span> {listing.titleStatus}
          </li>
        )}
        {listing.transmission && (
          <li>
            <span>Transmission:</span> {listing.transmission}
          </li>
        )}
        {listing.engineCondition && (
          <li>
            <span>Engine condition:</span> {listing.engineCondition}
          </li>
        )}
        {listing.odometer && (
          <li>
            <span>Odometer:</span> {listing.odometer}
          </li>
        )}
        {listing.engineSize && (
          <li>
            <span>Engine size:</span> {listing.engineSize}
          </li>
        )}
        {listing.engineHistory && (
          <li>
            <span>Engine history:</span> {listing.engineHistory}
          </li>
        )}
        {listing.vehicleRestorationHistory && (
          <li>
            <span>Vehicle restoration history:</span> {listing.vehicleRestorationHistory}
          </li>
        )}
      </ul>
      <div className='mt-4'>
        {listing.vehicleRestorationHistoryExplained && (
          <>
            <h3 className='text-lg font-semibold'>Description of restoration history: </h3>
            <div className='text-sm text[#140C07] mt-4'>{listing.vehicleRestorationHistoryExplained}</div>
          </>
        )}
      </div>
    </section>
  );
}
